export function isAbortError(err: any) {
  return err && err.name === 'AbortError';
}

export const ErrorMessage = 'An unexpected condition occurred, please contact your system administrator for more help';

export interface IDecisionsApiError {
  responseText: string;
}

export interface ErrorDetails {
  Title: string;
  Description: string;
  IsSecurityException: boolean;
  Type?: string;
  Statue?: string;
  Instance?: string;
}

export function isDecisionsApiError(error: object | null): error is IDecisionsApiError {
  return !!error && error.hasOwnProperty('responseText');
}
